export class UsuarioRestriccion{
    id: String="";
    usuario_id_restriccion: String="";
    hora_desde: String="";
    hora_hasta: String="";
    status: String="";
    empresa_id: String="";
    usuario_id: String="";

    constructor(data?: IUsuarioRestriccion){
        if(data){
            for(var property in data){
                if(data.hasOwnProperty(property)){
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }

    /*init(data?: any){

    }*/
    
}
export class IUsuarioRestriccion{
    id: String;
    usuario_id_restriccion: String;
    hora_desde: String;
    hora_hasta: String;
    status: String;
    empresa_id: String;
    usuario_id: String;
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/usuario_restriccion.ts